import * as reservedInstanceConst from './constants';

export default {
    [reservedInstanceConst.describeResProduct](state, res) {
        state.list = res.list;
        state.total = res.total
    },
};
